module.exports = __webpack_public_path__ + "img/Binosto-logo-dark.f8de39b7.svg";